/** KOT calendar / reservation grid size presets (admin: KOT Setting). */
export const CALENDAR_DISPLAY_SIZES = [
  { value: 'compact', label: 'Compact (small screen)' },
  { value: 'medium', label: 'Medium (default)' },
  { value: 'large', label: 'Large' },
  { value: 'pos', label: 'POS / touch (largest)' },
];

const PRESETS = {
  compact: { dayCol: 48, leftCol: 188, laneBar: 24, fontScale: 0.9 },
  medium: { dayCol: 56, leftCol: 220, laneBar: 28, fontScale: 1 },
  large: { dayCol: 64, leftCol: 252, laneBar: 32, fontScale: 1.12 },
  pos: { dayCol: 76, leftCol: 296, laneBar: 36, fontScale: 1.28 },
};

export function normalizeCalendarDisplaySize(value) {
  const key = String(value || 'medium')
    .toLowerCase()
    .trim();
  return Object.prototype.hasOwnProperty.call(PRESETS, key) ? key : 'medium';
}

export const CALENDAR_TEXT_ALIGN_OPTIONS = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Right' },
];

export function normalizeCalendarTextAlign(value) {
  const key = String(value || 'left')
    .toLowerCase()
    .trim();
  return CALENDAR_TEXT_ALIGN_OPTIONS.some((o) => o.value === key) ? key : 'left';
}

function clampInt(value, min, max) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  const v = Math.round(n);
  if (v < min || v > max) return null;
  return v;
}

/**
 * @param {string} sizeKey preset key
 * @param {object} [overrides] kot-configuration fields (optional px overrides)
 */
export function getCalendarDisplayMetrics(sizeKey, overrides = {}) {
  const key = normalizeCalendarDisplaySize(sizeKey);
  const metrics = { key, ...PRESETS[key] };

  const dayCol = clampInt(overrides.calendar_day_col_px, 32, 120);
  const laneBar = clampInt(overrides.calendar_row_height_px, 16, 64);
  const headerDayHeight = clampInt(overrides.calendar_header_height_px, 28, 80);

  if (dayCol != null) metrics.dayCol = dayCol;
  if (laneBar != null) metrics.laneBar = laneBar;
  if (headerDayHeight != null) metrics.headerDayHeight = headerDayHeight;

  metrics.textAlign = normalizeCalendarTextAlign(overrides.calendar_text_align);

  return metrics;
}
